import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { isSoundEnabledAtom } from '../atom/Atom';

const bgmAudio = new Audio();
bgmAudio.loop = true;

const seAudio = new Audio();
let resumeBgm: (() => void) | undefined;

export const useAudio = () => {
  const isSoundEnabled = useAtomValue(isSoundEnabledAtom);

  const stopBgmAudio = useCallback(() => {
    bgmAudio.pause();
    bgmAudio.currentTime = 0;
    bgmAudio.src = '';
  }, []);

  const stopAllAudio = useCallback(() => {
    stopBgmAudio();
    if (resumeBgm) seAudio.removeEventListener('ended', resumeBgm);
    resumeBgm = undefined;
    seAudio.pause();
    seAudio.currentTime = 0;
    seAudio.src = '';
  }, [stopBgmAudio]);

  const playBgmAudio = useCallback(
    (src: string) => {
      if (!isSoundEnabled) {
        stopBgmAudio();
        return;
      }
      bgmAudio.pause();
      bgmAudio.currentTime = 0;
      bgmAudio.src = src;
      bgmAudio.play().catch((error) => {
        if (error.name !== 'AbortError') {
          console.error('Error playing BGM audio:', error);
        }
      });
    },
    [isSoundEnabled, stopBgmAudio]
  );

  const playSeAudio = useCallback(
    (src: string, bgmSrc: string = '') => {
      if (resumeBgm) seAudio.removeEventListener('ended', resumeBgm);
      resumeBgm = undefined;
      if (!isSoundEnabled) {
        seAudio.pause();
        seAudio.currentTime = 0;
        seAudio.src = '';
        return;
      }
      seAudio.pause();
      seAudio.currentTime = 0;
      seAudio.src = src;
      seAudio.play().catch((error) => {
        if (error.name !== 'AbortError') {
          console.error('Error playing SE audio:', error);
        }
      });

      // SE再生後にBGMを再開する
      if (bgmSrc) {
        resumeBgm = () => {
          bgmAudio.src = bgmSrc;
          bgmAudio.play().catch((error) => {
            if (error.name !== 'AbortError') {
              console.error('Error resuming BGM audio:', error);
            }
          });
        };
        seAudio.addEventListener('ended', resumeBgm, { once: true });
      }
    },
    [isSoundEnabled]
  );

  return {
    playBgmAudio,
    stopBgmAudio,
    stopAllAudio,
    playSeAudio,
  };
};
